import { CONTACT } from 'customer-data-objects/constants/ObjectTypes';
import { getProperty } from 'customer-data-objects/record/ObjectRecordAccessors';
import { LAST_ENGAGEMENT } from 'customer-data-objects/task/TaskPropertyNames';
// @ts-expect-error untyped
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import PropTypes from 'prop-types';
import { CONTACT as CONTACT_REFERENCE_TYPE, TASK_LAST_ENGAGEMENT
// @ts-expect-error untyped
} from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped
import ResolveReferences from 'reference-resolvers/ResolveReferences';
// @ts-expect-error untyped
import { isError, isLoading, isResolved } from 'reference-resolvers/utils';
import compose from 'transmute/compose';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { ALL_ACTIVITY_TYPES } from '../../constants/activityTypes';
import { jsx as _jsx } from "react/jsx-runtime";
function getActivityOriginData(resolvedLastEngagement) {
  const activityOriginId = getIn(['referencedObject', 'activity', 'activityOriginId'], resolvedLastEngagement);
  const activityOriginType = getIn(['referencedObject', 'activity', 'activityOriginType'], resolvedLastEngagement);
  return {
    activityOriginType,
    activityOriginId
  };
}
export function ActivityDescription({
  resolvedLastEngagement,
  resolvedContact
}) {
  const {
    activityOriginId,
    activityOriginType
  } = getActivityOriginData(resolvedLastEngagement);
  const hasAssociatedContact = Boolean(activityOriginType === CONTACT && activityOriginId);
  const loading = isLoading(resolvedLastEngagement) || hasAssociatedContact &&
  // the resolvedContact can sometimes be null when its still loading because the way this reference depends
  // on the lastEngagement resolver, so isLoading can't be trusted entirely
  !isResolved(resolvedContact) && !isError(resolvedContact);
  const error = isError(resolvedLastEngagement) || isError(resolvedContact);
  if (loading) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      size: "extra-small",
      use: "on-dark",
      layout: "inline",
      grow: true
    });
  }
  const activityType = getIn(['referencedObject', 'activity', 'activityType'], resolvedLastEngagement);
  const isValidActivityType = activityType && ALL_ACTIVITY_TYPES.includes(activityType);
  const displayName = get('label', resolvedContact);
  if (error || !isValidActivityType || !displayName) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasksAlerts.tableCellError"
    });
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `tasks-table.cells.lastEngagement.activityDescriptions.${activityType}`,
    options: {
      formattedName: resolvedContact.label
    }
  });
}
ActivityDescription.propTypes = {
  resolvedContact: PropTypes.object,
  resolvedLastEngagement: PropTypes.object
};
const mapContactResolverToActivityDescription = (resolvers, props) => {
  const {
    activityOriginId,
    activityOriginType
  } = getActivityOriginData(props.resolvedLastEngagement);
  const hasAssociatedContact = Boolean(activityOriginType === CONTACT && activityOriginId);
  if (hasAssociatedContact) {
    return {
      resolvedContact: resolvers[CONTACT_REFERENCE_TYPE].byId(activityOriginId)
    };
  }
  return {};
};
const mapLastEngagementResolverToActivityDescription = (resolvers, props) => {
  return {
    resolvedLastEngagement: resolvers[TASK_LAST_ENGAGEMENT].byId(props.task.objectId)
  };
};

// This maps both resolvers to the props on ActivityDescription.
// Order is important because the Contact depends on the Last Engagement
const ResolvedActivityDecription = compose(ResolveReferences(mapLastEngagementResolverToActivityDescription), ResolveReferences(mapContactResolverToActivityDescription))(ActivityDescription);
function LastEngagementCell({
  original: task
}) {
  const timestamp = Number(getProperty(task, LAST_ENGAGEMENT));
  if (!timestamp) {
    return /*#__PURE__*/_jsx("div", {
      children: "--"
    });
  }
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(ResolvedActivityDecription, {
      task: task
    }),
    children: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedDuration, {
        from: new Date(),
        to: new Date(timestamp),
        includeAffix: true
      })
    })
  });
}
export default LastEngagementCell;